
(() => {
 if (window.onimaPilotReviewJump) return;
 window.onimaPilotReviewJump = true;
 document.addEventListener('click', event => {
  const link = event.target.closest('.on-pilot [data-on-review-jump],.on-pilot .jdgm-preview-badge');
  if (!link) return;
  const section = document.querySelector('.on-pilot #on-reviews');
  if (!section) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  const header = document.querySelector('.header-sections');
  const nav = document.querySelector('.on-pilot .on-pdp-nav');
  const offset = (header?.getBoundingClientRect().height || 0) + (nav?.getBoundingClientRect().height || 0) + 20;
  window.scrollTo({top: section.getBoundingClientRect().top + window.scrollY - offset, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  section.focus({preventScroll:true});
 }, true);
})();

document.addEventListener('change', event => {
 const select=event.target.closest('[data-on-kit-variant]');
 if(!select)return;
 const option=select.selectedOptions[0],form=select.closest('form');
 const available=option.dataset.available==='true';
 const button=form.querySelector('[type="submit"]'),quantity=form.querySelector('[name="quantity"]');
 button.disabled=!available;
 button.querySelector('span').textContent=available?select.dataset.addLabel:select.dataset.soldLabel;
 quantity.disabled=!available;
 quantity.max=String(Math.max(0,Number(option.dataset.limit)));
 if(available)quantity.value=String(Math.max(1,Math.min(Number(quantity.value)||1,Number(quantity.max))));
 document.querySelectorAll('[data-on-bundle-price]').forEach(node=>node.textContent=option.dataset.price);
 const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);
 form.querySelector('.on-form-status').textContent='';
});
